export default "__VITE_ASSET__cQ7rosnD__"